import { render, staticRenderFns } from "./FeedbackInbox.vue?vue&type=template&id=df8f062a&scoped=true"
import script from "./FeedbackInbox.vue?vue&type=script&lang=js"
export * from "./FeedbackInbox.vue?vue&type=script&lang=js"
import style0 from "./FeedbackInbox.vue?vue&type=style&index=0&id=df8f062a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df8f062a",
  null
  
)

export default component.exports